module.exports = __webpack_public_path__ + "static/avatar-4d20658fd9fc7cfe8ceb492c9705649e.gif";